<template>
  <div class="wg-row wg-xs-12">
    <div class="wg-col wg-xs-12 wg-lg-7">
      <template v-if="!showNewPlaceView">
        <!-- Custom component for set-place-flow, if present -->
        <component
            v-if="customComponent"
            :is="customComponent"
            :projectId="project.idWorldProject"
            @done="customComponent = null"
        ></component>
        <h1 class="com-anm22-page-title">
          {{ $anm22.strLang(lang, 'Project place', 'Luogo del progetto') }}
        </h1>
        <div v-if="place" class="wg-row">
          <div class="wg-col wg-xs-12">
            <w-g-world-place-container :place="place" :assoc="getAssoc(place)" :extended="true"></w-g-world-place-container>
          </div>
        </div>
        <div class="vertical-height-div" style="height:15px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="margin-top:5px;">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, 'Default timezone', 'Fuso orario predefinito') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <select class="com-anm22-app-select" v-model="timezone">
              <option default disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option 
                  v-for="(timezone, key, index) in $anm22.tableClasses.worldTimezone().getAll()"
                  :key="'timezone-'+index"
                  :value="key">{{ timezone[lang] }}</option>
            </select>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6" style="margin-top:5px;">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, 'Default currency', 'Valuta predefinita') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <select class="com-anm22-app-select" v-model="currencyType">
              <option default disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option 
                  v-for="(currencyType, key, index) in $anm22.tableClasses.worldCurrencyType().getAll()"
                  :key="'currency-'+index"
                  :value="key">{{ currencyType[lang] }}</option>
            </select>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <input 
            type="button" 
            :value="$anm22.strLang(lang, 'Save', 'Salva')" 
            @click="saveProject">
        <div class="vertical-height-div" style="height:40px;"></div>
        <template v-if="!offline">
          <div v-if="place" class="wg-row">
            <div class="wg-col wg-xs-12">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Change place', 'Cambia luogo') }}
              </div>
            </div>
          </div>
          <div v-else class="wg-row">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, 'Select place', 'Seleziona luogo') }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <template v-if="!((assocs.length === 0) || (place && (assocs.length === 1) && (assocs[0].place === place.idWorldPlace)))">
            <div 
                v-for="(a, index) in assocs.filter(a => this.place ? a.place !== this.place.idWorldPlace : true)"
                :key="'wp'+index"
                class="wg-row"
                style="cursor:pointer;"
                @click="setPlace(a.place)">
              <img 
                  :src="placeIcon(a)"
                  :title="placeLabel(a)"
                  class="com-anm22-app-img-fixed-height-s com-anm22-round"
              >
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div class="com-anm22-app-text-m">
                  {{ placeLabel(a) }}
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
            </div>
          </template>
          <div 
            class="wg-row"
            style="cursor:pointer;"
            @click="showNewPlaceView = true">
            <img 
              :src="$anm22.icons.getWorldIcon('add')"
              class="com-anm22-app-img-fixed-height-s com-anm22-round"
            >
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, 'Create new site', 'Crea nuova sede') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </template>
      </template>
      <div v-if="showNewPlaceView" class="wg-row">
        <div class="wg-row">
          <div class="com-anm22-app-text-xxl">{{ $anm22.strLang(lang, 'New site', 'Nuova sede') }}</div>
        </div>
        <div class="wg-row">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
              <div class="wg-row input-elem" style="aling-items:center;">
                <input
                  class="com-anm22-app-input-text"
                  style="width:200px;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  v-model="newPlace.name"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Address', 'Indirizzo') }}</div>
              <div class="wg-row input-elem" style="aling-items:center;">
                <input
                  class="com-anm22-app-input-text"
                  style="width:155px;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                  v-model="newPlace.addressStreet"
                >
                <input
                  class="com-anm22-app-input-text"
                  style="width:40px;margin-left:5px;"
                  type="text"
                  placeholder="N."
                  v-model="newPlace.addressNumber"
                >
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'City', 'Città') }}</div>
              <input
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'City', 'Città')"
                v-model="newPlace.addressCity"
              >
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'ZIP', 'CAP') }}</div>
              <input
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
                v-model="newPlace.addressZip"
              >
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'State', 'Provincia') }}</div>
              <input
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
                v-model="newPlace.addressState"
              >
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Country', 'Paese') }}</div>
              <select class="input-elem com-anm22-app-select" v-model="newPlace.addressCountry">
                <option
                  value
                  selected
                  disabled
                  hidden
                >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                <option
                  v-for="obj in Object.values($anm22.tableClasses.worldCountry().getAll()).sort((a, b) => (a[lang] < b[lang]) ? -1 : (b[lang] > b[lang]) ? 1 : 0)"
                  :key="'country-'+ obj.typeClassLiteral"
                  :value="obj.typeClassLiteral"
                >{{ obj[lang] }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}</div>
              <select class="input-elem com-anm22-app-select" v-model="newPlace.timezone">
                <option
                  value
                  selected
                  disabled
                  hidden
                >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                <option
                  v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                  :key="'timezone-'+index"
                  :value="key"
                >{{ obj[lang] }}</option>
              </select>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Currency', 'Valuta') }}</div>
              <select class="input-elem com-anm22-app-select" v-model="newPlace.currencyType">
                <option
                  value
                  selected
                  disabled
                  hidden
                >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                <option
                  v-for="(obj,key,index) in $anm22.tableClasses.worldCurrencyType().getAll()"
                  :key="'currency-'+index"
                  :value="key"
                >{{ obj[lang] }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <input
            type="button"
            class="small"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveNewPlace"
          >
          <input
            type="button"
            class="small red"
            style="margin-left:10px;"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="showNewPlaceView = false"
          >
        </div>
        <div class="vertical-height-div" style="height:60px;"></div>
      </div>
      <!-- <div class="vertical-height-div" style="height:20px;"></div> -->
      <!-- <a href="https://www.anm22.it/app/work/viewPricings.php">
        <input 
            type="button" 
            :value="$anm22.strLang(lang, 'Manage customers', 'Gestisci clienti')">
      </a> -->
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('placeBlack')" />
      <div style="padding:0 20px">
        <strong>{{$anm22.strLang(lang, 'Set place', 'Imposta luogo')}}</strong><br />
        {{$anm22.strLang(lang, '', 'Indica dove si svolge il progetto, in modo da adattare il fuso orario e la valuta per le spese.')}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGWorldPlaceContainer from '../../../../../../world/spa/components/WGWorldPlaceContainer.vue';

export default {
  props: {
    data: Object
  },
  data() {
    return {
      customComponent: null,
      loading: false,
      showNewPlaceView: false,
      newPlace: {},
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      offline: state => state.offline.isOffline
    }),
    project() {
      return this.$store.getters['projects/get'](this.data.project.idWorldProject);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters["licenses/getByWork"](e.work))
        .filter(l => l);
    },
    place() {
      return this.project.place ? this.$store.getters['places/get'](this.project.place) : null;
    },
    assocs() {
      let assocs = [];
      this.project.developers.forEach(w => {
        assocs = assocs.concat(
          this.$store.getters['workPlaceAssocs/getByWork'](w)
        );
      });
      this.project.customers.forEach(c => {
        assocs = assocs.concat(
          this.$store.getters['contactPlaceAssocs/getByContact'](c)
        );
      });
      return assocs;
    },
    timezone: {
      get() {
        if(this.project && this.project.timezone) {
          return this.project.timezone;
        } else {
          if(!this.loading && this.assocs.length > 0) {
            const place = this.$store.getters['places/get'](this.assocs[0].place);
            return place.timezone;
          } else {
            const objs = this.$anm22.tableClasses.worldTimezone().getAll();
            return Object.keys(objs)[0];
          }
        }
      }, 
      set(val) {
        this.project.timezone = val;
      }
    },
    currencyType: {
      get() {
        if(this.project && this.project.currencyType) {
          return this.project.currencyType;
        } else {
          if(!this.loading && this.assocs.length > 0) {
            const place = this.$store.getters['places/get'](this.assocs[0].place);
            return place.currencyType;
          } else {
            const objs = this.$anm22.tableClasses.worldCurrencyType().getAll();
            return Object.keys(objs)[0];
          }
        }
      }, 
      set(val) {
        this.project.currencyType = val;
      }
    }
  }, 
  methods: {
    getAssoc(place) {
      return this.assocs.find(a => a.place === place.idWorldPlace);
    },
    placeIcon(a) {
      if(a.work) {
        return this.$anm22.getObjIcon(this.$store.getters['works/get'](a.work), 'workDefault');
      } else {
        return this.$anm22.getContactIcon(this.$store.getters['contacts/get'](a.contact), this.$store);
      }
    },
    placeLabel(a) {
      const place = this.$store.getters['places/get'](a.place);
      if(place) {
        return place.name + ', ' + this.$anm22.getAddressFromPlace(this, place);
      } else {
        return '';
      }
    },
    saveProject() {
      this.$http
        .post('/project/edit/', {
          project: this.project
        }, {
          withCredentials: true
        })
        .then(response => {
          //Salvo con localForage
          this.$store.dispatch('projects/update', {
            vlf: this.$vlf('projects'),
            objs: response.data.projects
          })
          .then(() => {
            this.$Progress.finish();
          })
          .catch(error => console.log(error));
        })
        .catch(error => {
          /* Salvo l'oggetto nel db */
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: 'edit',
              type: 'obj',
              obj: this.project
            }),
            // this.$anm22.saveSyncTuple(this, 'WorldProject', 'edit', this.project)
          ])
          .then(result => {
            this.$Progress.finish();
          })
          .catch(error => console.log(error));
        });
    },
    saveNewPlace() {
      let place = null;
      let placeId = null;
      this.$http
        .post("project/new-place", {
          projectId: this.project.idWorldProject,
          place: this.newPlace
        }, {
          withCredentials: true
        })
        .then(response => {
          place = response.data.place;
          placeId = place.idWorldPlace;
          Promise.all([
            this.$store.dispatch("places/update", {
              vlf: this.$vlf("places"),
              objs: [place]
            })
          ]);
        })
        .catch(error => {
          /* No offline yet */
        })
        .finally(() => {
          this.setPlace(placeId);
          this.showNewPlaceView = false;
        });
    },
    setPlace(placeId) {
      if (!placeId) {
        console.log("Place ID doesn't set.");
        return;
      }
      this.$http
        .post("/project/place/", {
          projectId: this.project.idWorldProject,
          placeId: placeId
        }, {
          withCredentials: true
        })
        .then(response => {
          //update di projects e workPlaceAssocs
          this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
          })
          .then(() => {
            //Customizzazione setPlace in config di licenza
            if(this.licenses.length > 0) {
              // Recupero la prima licenza che possiede una customizzazione
              const license = this.licenses
                  .find(l => l.config 
                      && l.config.tasks 
                      && l.config.tasks['set-place-flow']
                      && l.config.tasks['set-place-flow'].type !== '');
              if(license) {
                const type = license.config.tasks['set-place-flow'].type;
                if(type === 'function') {
                  this.$anm22[license.config.tasks['set-place-flow'].name](this);
                } else if(type === 'component') {
                  const componentPath = license.config.tasks['set-place-flow'].name;
                  this.customComponent = () => import("../../custom/" + componentPath);
                }
              }
            }
          })
          .catch(error => console.log(error));
        })
        .catch(error => {
        });
    },
    loadData() {
      Promise.all([
        this.$store.dispatch('contactPlaceAssocs/load', this.$vlf('contactPlaceAssocs')),
        this.$store.dispatch('workPlaceAssocs/load', this.$vlf('workPlaceAssocs')),
        this.$store.dispatch('places/load', this.$vlf('places'))
      ])
      .then(() => {
        this.$Progress.finish();
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });        
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    this.$http.get('project/place?idProject='+this.$route.params.id)
      .then(response => {
        Promise.all([
          this.$store.dispatch('contactPlaceAssocs/update', {
              vlf: this.$vlf('contactPlaceAssocs'),
              objs: response.data.contactPlaceAssocs
          }),
          this.$store.dispatch('workPlaceAssocs/update', {
              vlf: this.$vlf('workPlaceAssocs'),
              objs: response.data.workPlaceAssocs
          }),
          this.$store.dispatch('places/update', {
              vlf: this.$vlf('places'),
              objs: response.data.places
          })
        ])
        .catch(error => console.log(error))
      })
      .catch(error => console.log(error));
  },
  components: {
    WGWorldPlaceContainer
  }
}
</script>

<style lang="scss" scoped>
.input-elem {
  max-width: 200px;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
</style>
